import CheckIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/InfoRounded';
import MuiCardContent from '@mui/material/CardContent';
import Modal from '@mui/material/Modal';
import { alpha, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { Card, ColorIndicator } from '@qpr/components';
import React, { useContext } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { ActiveSipocId } from '../views/SIPOCView';

const PREFIX = 'Process';

const classes = {
  cardMui: `${PREFIX}-cardMui`,
  details: `${PREFIX}-details`,
  linkStyle: `${PREFIX}-linkStyle`,
  modal: `${PREFIX}-modal`,
  infoIcon: `${PREFIX}-infoIcon`,
  infoIconDiv: `${PREFIX}-infoIconDiv`,
  infoIconDivActive: `${PREFIX}-infoIconDivActive`,
  checkIconDiv: `${PREFIX}-checkIconDiv`,
  headerRow: `${PREFIX}-headerRow`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')(({ theme }) => ({
  [`& .${classes.cardMui}`]: {
    display: 'flex',
    backgroundColor: alpha(theme.palette.background.paper, 0.8),
    height: '132px'
  },

  [`& .${classes.details}`]: {
    position: 'relative',
    width: '100%'
  },

  [`& .${classes.linkStyle}`]: {
    textDecoration: 'none',
    color: theme.palette.text.primary
  },

  [`& .${classes.modal}`]: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  [`& .${classes.infoIcon}`]: {
    position: 'absolute',
    top: '80px',
    left: '20px',
    color: theme.palette.primary.main
  },

  [`& .${classes.infoIconDiv}`]: {},
  [`& .${classes.infoIconDivActive}`]: {},

  [`& .${classes.checkIconDiv}`]: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    color: theme.palette.primary.main
  },

  [`& .${classes.headerRow}`]: {
    alignItems: 'center',
    display: 'flex'
  }
}));

export interface ProcessCard {
  title: string;
  url: string;
  active?: boolean;
  id: string;
  sipocid: string;
  rangecolor?: string;
}
type ProcessProps = {
  /**  process card information */
  item: ProcessCard;
};

export default function Process({ item }: ProcessProps) {
  const [modalOpen, setModalOpen] = React.useState(false);

  const colorIndicatorClickHandler = (event: React.MouseEvent<HTMLElement>): void => {
    if (event.currentTarget.parentElement?.className === classes.infoIconDivActive) {
      event.preventDefault();
    }

    setModalOpen(true);
  };
  const modalCloseHandler = (): void => {
    setModalOpen(false);
  };
  const active = item.sipocid === useContext(ActiveSipocId).valueOf() || item.active;

  return (
    <Root>
      {item.url && (
        <RouterLink to={active ? '../-/' : item.url} className={classes.linkStyle}>
          <Card className={classes.cardMui}>
            <div className={classes.details} data-testid="sipoc-process-card">
              <MuiCardContent className={classes.headerRow}>
                <ColorIndicator
                  color={item.rangecolor ? item.rangecolor : 'transparent'}
                  onClick={colorIndicatorClickHandler}
                />
                <Typography variant="subtitle1">{item.title}</Typography>
              </MuiCardContent>
              <div className={active ? classes.infoIconDivActive : classes.infoIconDiv}>
                <InfoIcon
                  fontSize="large"
                  onClick={() => console.log('clicked info icon')}
                  className={classes.infoIcon}
                  data-testid="sipoc-process-info-icon"
                />
              </div>
              {active && (
                <div
                  className={`SelectedItem ${classes.checkIconDiv}`}
                  data-testid="sipoc-selected-process"
                >
                  <CheckIcon fontSize="large" />
                </div>
              )}
            </div>
          </Card>
        </RouterLink>
      )}
      {!item.url && (
        <Card className={classes.cardMui}>
          <div className={classes.details} data-testid="sipoc-process-card">
            <MuiCardContent className={classes.headerRow}>
              <ColorIndicator
                color={item.rangecolor ? item.rangecolor : 'transparent'}
                onClick={colorIndicatorClickHandler}
              />
              <Typography variant="subtitle1">{item.title}</Typography>
            </MuiCardContent>
            <div className={classes.infoIconDiv}>
              <InfoIcon
                fontSize="large"
                onClick={() => console.log('clicked info icon')}
                className={classes.infoIcon}
                data-testid="sipoc-process-info-icon"
              />
            </div>
          </div>
        </Card>
      )}
      <Modal
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modal}
        open={modalOpen}
        onClose={modalCloseHandler}
      >
        <div>modal placeholder</div>
      </Modal>
    </Root>
  );
}
